import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';

const LEGACY_CANVAS_SERVER_URL = '/gateway/api/canvas';
const CANVAS_TENANT_CONTEXT_URL_PREFIX = '/gateway/api/canvas-tenant-context/site';
const DATABASES_TENANT_CONTEXT_ROUTE_FLAG =
  'databases-collab-use-canvas-tenant-context-route';

export const getCanvasServerUrl = (siteId: string) => {
  if (isFeatureFlagEnabled(DATABASES_TENANT_CONTEXT_ROUTE_FLAG)) {
    if (!siteId) {
      throw new Error('siteId is not defined');
    }

    return `${CANVAS_TENANT_CONTEXT_URL_PREFIX}/${siteId}`;
  }

  return LEGACY_CANVAS_SERVER_URL;
};
